export default __webpack_public_path__ + "static/media/LotusGofreshFloorPlan.3081b5c1.svg";